import { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const PopupPortal = ({ children }) => {
  const [portalElement, setPortalElement] = useState(null);

  useEffect(() => {
    // Create a div element for the portal
    const element = document.createElement('div');
    element.setAttribute('id', 'popup-portal-root');
    document.body.appendChild(element);
    setPortalElement(element);

    // Clean up function
    return () => {
      document.body.removeChild(element);
    };
  }, []);

  // Don't render until the portal element is created
  if (!portalElement) return null;

  return ReactDOM.createPortal(children, portalElement);
};

export default PopupPortal;